import React from "react";
import * as Accordion from "@radix-ui/react-accordion";

import styles from "./Accordion.module.css";

export type AccordionProps = Omit<JSX.IntrinsicElements["div"], "ref"> &
  Accordion.AccordionSingleProps;

export const Root = React.forwardRef<HTMLDivElement, AccordionProps>(
  ({ className = "", ...props }, ref) => {
    return <Accordion.Root className={className} {...props} ref={ref} />;
  }
);

Root.displayName = "Accordion.Root";

export const Item = React.forwardRef<
  HTMLDivElement,
  Accordion.AccordionItemProps
>(({ className = "", ...props }, ref) => {
  return <Accordion.Item className={className} {...props} ref={ref} />;
});

Item.displayName = "Accordion.Item";

export const Heading = React.forwardRef<
  HTMLButtonElement,
  Accordion.AccordionTriggerProps
>(({ className = "", children, ...props }, ref) => {
  return (
    <Accordion.Header className={`${styles.heading} ${className}`}>
      <Accordion.Trigger className={styles.trigger} {...props} ref={ref}>
        {children}
      </Accordion.Trigger>
    </Accordion.Header>
  );
});

Heading.displayName = "Accordion.Heading";

export const Content = React.forwardRef<
  HTMLDivElement,
  Accordion.AccordionContentProps
>(({ className = "", children, ...props }, ref) => {
  return (
    <Accordion.Content
      className={`${styles.content} ${className}`}
      {...props}
      ref={ref}
    >
      <div>{children}</div>
    </Accordion.Content>
  );
});

Content.displayName = "Accordion.Content";
